import { Icon } from '@/general/Icons/Icon';
import { ReactNode } from 'react';

import { FilterName } from '@/plp/components/FilterName/FilterName';

import { FilterOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterOptionFieldsGroup } from '../components/Fields/FilterOptionFieldsGroup';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = Prettify<
  PlpHierarchyFilterItemProps<FilterOption> & {
    driveTrainHelper?: ReactNode;
  }
>;

export const FilterDriveType = ({
  options,
  currentFilters,
  driveTrainHelper,
  index,
  showNotificationBadge,
  ...props
}: Props) => {
  const id = 'driveType';
  const header = (
    <FilterName icon={<Icon name="drive-type" />} label="Drivetrain" showNotificationBadge={showNotificationBadge} />
  );
  const content = (
    <>
      <FilterOptionFieldsGroup
        options={options.map((option) => ({ ...option, label: option.label ?? '' }))}
        currentFilters={currentFilters}
        {...props}
      />
      <div className="mt-4">{driveTrainHelper}</div>
    </>
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
